import { t } from '@ankr.com/common';

import { AppDispatch } from 'store';
import { NotificationActions } from 'domains/notifications/store/NotificationActions';

import { isAxiosAuthError } from './isAxiosAuthError';

export interface HandlePermanentTokenErrorParams {
  dispatch: AppDispatch;
  error: unknown;
}

const { showNotification } = NotificationActions;

export const handlePermanentTokenError = ({
  dispatch,
  error,
}: HandlePermanentTokenErrorParams) => {
  const severity = 'error';

  const message = isAxiosAuthError(error)
    ? t('error.auth-token-expired')
    : t('error.auth-unknown');

  dispatch(showNotification({ message, severity }));
};
